export default "__VITE_ASSET__ef5VcjSi__"